import mitt from "mitt";
const emitter = mitt();

interface Bus {
  readonly $on: Function;
  readonly $off: Function;
  readonly $emit: Function;
}

const eventBus: Bus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
};

export default eventBus;
